import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cancelFunctions } from 'utils/cancelFunctions';
import {
  initialOOCReport,
  setCampaignsWithOOCFrames as setProgrammaticCampaignsWithOOCFrames,
} from 'store/pages/programmaticOOC/reducer';
import { getTotalOOCDealLineCount } from 'store/pages/programmaticOOC/selectors';
import { addToastNotification } from 'store/notification/reducer';
import { getProgrammaticCampaignsWithOOCFrames } from 'modules/api/programmaticOOC';
import { isCanceledError } from 'modules/api/request';

export interface UseOOCReportResult {
  totalOOCDealLineCount: number;
}

export const useOOCReport = (): UseOOCReportResult => {
  const dispatch = useDispatch();

  const totalOOCDealLineCount = useSelector(getTotalOOCDealLineCount);

  useEffect(() => {
    const fetchCampaignsWithOOCFrames = async (): Promise<void> => {
      try {
        const response = await getProgrammaticCampaignsWithOOCFrames(cancelFunctions);

        dispatch(setProgrammaticCampaignsWithOOCFrames(response));
      } catch (error) {
        dispatch(setProgrammaticCampaignsWithOOCFrames(initialOOCReport));

        if (!isCanceledError(error)) {
          dispatch(addToastNotification({ description: 'Failed to load OOC report', type: 'Failure' }));
        }
      }
    };

    fetchCampaignsWithOOCFrames();

    return () => {
      dispatch(setProgrammaticCampaignsWithOOCFrames(initialOOCReport));
    };
  }, []);

  return { totalOOCDealLineCount };
};
